import React, { useEffect, useState } from 'react'
import { FormInstance } from 'antd'
import ReactQuill from 'react-quill'

import 'react-quill/dist/quill.snow.css'
import './index.less'

const modules = {
	toolbar: [
		[{ header: [1, 2, false] }],
		['bold', 'italic', 'underline'],
		[{ list: 'ordered' }, { list: 'bullet' }],
		['clean'],
	],
}

type TProps = {
	form: FormInstance
}

const BioEditor = (props: TProps) => {
	const { form } = props
	const [text, setText] = useState<string>('')
	const [className, setClassName] = useState<string>('')
	const defaultText = form?.getFieldsValue().bio
	useEffect(() => {
		const bioError = form.getFieldsError().find((error: any) => error.name[0] === 'bio' && error.errors.length)
		setClassName(bioError ? 'error' : '')
	}, [form.getFieldsError()])

	useEffect(() => {
		if (!text && defaultText) {
			setText(defaultText)
		}
	}, [defaultText, text])

	const onChange = (value: string) => {
		const values = form.getFieldsValue()
		setText(value)
		form.setFieldsValue({
			...values,
			bio: value === '<p><br></p>' ? '' : value,
		})
	}

	return <ReactQuill className={`bio-editor ${className}`} value={text} onChange={onChange} modules={modules} />
}

export default BioEditor
